module.exports = __webpack_public_path__ + "img/1723083535043-bforest.jpg.5c8690a4.webp";